<template>
  <div>
    <datatable
      title="Question Options"
      @create="createQuestionOption"
      @delete="deleteQuestionOption"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-questions',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'text',
          value: 'text'
        },
        {
          name: 'option_order',
          value: 'option_order'
        },
        {
          name: 'selected_by_default',
          value: 'selected_by_default'
        },
        {
          name: 'question_id',
          value: 'question_id'
        }
      ],
      data: [],
      operations: [],
      question_id: this.$route.query.question_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getQuestionOptions({ question_id: this.question_id }).then(response => {
        this.data = response
      })
    },
    deleteQuestionOption (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.text,
        item_name: delete_data.text,
        method: 'deleteQuestionOption',
        method_params: { id: delete_data.id, question_id: this.question_id }
      })
    },
    createQuestionOption () {
      this.create({ designator: 'admin-question-options-form-modal', component_name: 'AdminQuestionOptionsForm', question_id: this.question_id, is_create: true, modal_title: 'Create new Question Option' })
    },
    editClick (data) {
      this.create({ designator: 'admin-question-options-form-modal', component_name: 'AdminQuestionOptionsForm', data, question_id: this.question_id, modal_title: data.text })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
